import { NotificationActivationPrompt } from '@/components/notifications/NotificationActivationPrompt';
import { useAuth } from '@/contexts/AuthContext';
import { useWebNotifications } from '@/hooks/useWebNotifications';

/**
 * Inner notifier — only mounted once a user is authenticated, so the hook
 * always has a stable user id and the shared notifications poll is active.
 */
function WebNotificationsActive({ userId }: { userId: string }): React.JSX.Element {
  useWebNotifications(userId);
  return <NotificationActivationPrompt />;
}

/**
 * WebNotificationsBootstrap — mounts inside AuthProvider (mirrors
 * IntercomBootstrap) and wires browser notifications across every
 * authenticated web surface. Renders nothing for unauthenticated visitors.
 */
export function WebNotificationsBootstrap(): React.JSX.Element | null {
  const { user, isAuthenticated } = useAuth();
  if (!isAuthenticated || !user) return null;
  return <WebNotificationsActive userId={user.id} />;
}
